import { slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import { RailContainer, OpenEnd, RailBackground } from './Rail.styles.js';
import { OPEN_ENDS, MAX, MIN } from '../constants.js';

var Rail = function Rail(_ref) {
  var _ref$max = _ref.max,
    max = _ref$max === void 0 ? MAX : _ref$max,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? MIN : _ref$min,
    _ref$openEnds = _ref.openEnds,
    openEnds = _ref$openEnds === void 0 ? undefined : _ref$openEnds,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    _ref$scaleFactor = _ref.scaleFactor,
    scaleFactor = _ref$scaleFactor === void 0 ? 1 : _ref$scaleFactor,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? [MIN, MAX] : _ref$value;
  var _value = _slicedToArray(value, 2),
    minValue = _value[0],
    maxValue = _value[1];
  var isMinOutOfBounds = maxValue < minValue;
  var isMaxOutOfBounds = maxValue > max;
  var left = isMinOutOfBounds ? 0 : (minValue - min) * scaleFactor;
  var right = isMaxOutOfBounds ? 0 : (max - maxValue) * scaleFactor;
  var displayOpenEndMin = [OPEN_ENDS.MIN, OPEN_ENDS.BOTH].includes(openEnds) && min === minValue;
  var displayOpenEndMax = [OPEN_ENDS.MAX, OPEN_ENDS.BOTH].includes(openEnds) && max === maxValue;
  return React__default.createElement(RailContainer, {
    $selected: selected,
    style: {
      left: left,
      right: right
    }
  }, displayOpenEndMin && React__default.createElement(OpenEnd, null), React__default.createElement(RailBackground, null), displayOpenEndMax && React__default.createElement(OpenEnd, null));
};
Rail.propTypes = {
  max: PropTypes.number,
  min: PropTypes.number,
  openEnds: PropTypes.oneOf(Object.values(OPEN_ENDS)),
  scaleFactor: PropTypes.number,
  selected: PropTypes.bool,
  value: PropTypes.arrayOf(PropTypes.number)
};
var Rail$1 = Rail;

export { Rail$1 as default };
//# sourceMappingURL=Rail.js.map
